<div class="wrapper">
  <div class="flex column first">
    <div class="claims-sum-amount">
      @for (claimSum of caseData.claim_sums | keyvalue; track claimSum.key; let last = $last) {
        <span class="amount">{{ claimSumRemainingAmount(claimSum.value) | number: "1.0" : "hu" }}&nbsp;</span>
        <span class="currency">{{ claimSum.key.toUpperCase() }}</span>
        @if (!last) {
          <span>&nbsp;+&nbsp;</span>
        }
      }
    </div>
  </div>
</div>
